import { RouteObject } from 'react-router-dom'
import { ReactNode } from 'react'

import { CustomRouteOption } from '~/apps/routes/RoutesTypes'
import { UnAuthRoute, PrivateRoute } from '~/apps/routes/components'

const getRouteElement = ({
    element,
    privateRoute,
    verifyAdmin,
    isQmrPage,
    getQuoteId,
    unAuthRoute,
}: CustomRouteOption): ReactNode => {
    let finalElement = element

    if (privateRoute) {
        finalElement = (
            <PrivateRoute
                isQmrPage={isQmrPage}
                verifyAdmin={verifyAdmin}
                getQuoteId={getQuoteId}
            >
                {element}
            </PrivateRoute>
        )
    } else if (unAuthRoute) {
        finalElement = <UnAuthRoute>{element}</UnAuthRoute>
    }

    return finalElement
}

/**
 * Function which maps our custom route configs {CustomRouteOption} to react-router config
 * For public routes it wraps elements with custom <PublicRoute> component
 * For private routes it wraps elements with custom <PrivateRoute> component
 * @param routes
 */
export const mapRoutesToReactRouter = (
    routes: CustomRouteOption[],
): RouteObject[] => {
    return routes.flatMap<RouteObject>(route => {
        const { index, path: incomingPath, children } = route
        const element = getRouteElement(route)

        if (index) {
            return {
                index,
                element,
            }
        }

        if (!incomingPath) {
            return []
        }

        let finalChildren: RouteObject[] | undefined

        if (children) {
            finalChildren = mapRoutesToReactRouter(children)
        }

        const paths: string[] =
            typeof incomingPath === 'string' ? [incomingPath] : incomingPath

        return paths.map(path => {
            return {
                path,
                element,
                children: finalChildren,
            }
        })
    })
}
